import React from 'react';
import Loader from 'react-dots-loader';
import './three-dots-loader.scss';

export enum DOTS_COLOR {
  PRIMARY = 'primary',
  DARK = 'dark',
  AI = 'ai',
}

interface ThreeDotsLoaderProps {
  extraClasses?: string;
  /**
   * whether to hide the loader or not
   */
  visible?: boolean;
  /**
   * the distance between each dot
   */
  distance?: number;
  /**
   * the size of each dot
   */
  size?: number;
  /**
   * a function to render your own dot JSX instead of the default
   */
  renderDot?: Function;

  color?: DOTS_COLOR;
}

const SIZE_DEFAULT = 12;
const DISTANCE_BETWEEN_DOTS_DEFAULT = 8;

/**
 * Generic wrapper component that exposes the react-dots-loader package.
 * Animated three dots typically used for displaying loading of inline items
 */
export function ThreeDotsLoader({distance = DISTANCE_BETWEEN_DOTS_DEFAULT, size = SIZE_DEFAULT, extraClasses = '', color = DOTS_COLOR.PRIMARY, ...props}: ThreeDotsLoaderProps) {
  return <Loader className={`three-dots-loader ${color} ${extraClasses}`} distance={distance} size={size} {...props} />;
}
